/**
 * 媒體廣場 — 繁體中文（對應 t('square.…')）
 */
export default {
	breadcrumb: "媒體廣場",
	tabs: {
		ariaLabel: "廣場內容分類",
		all: "全部",
		podcast: "播客",
		shorts: "Shorts",
		article: "圖文",
		creatorCenter: "創作中心",
	},
	index: {
		creatorCenterBtn: "+ 創作者中心",
	},
	recommend: {
		title: "播客",
		more: "更多 >",
		viewMorePodcast: "查看更多播客>",
	},
	shorts: {
		title: "Shorts",
		more: "更多 >",
	},
	article: {
		title: "圖文",
		more: "更多 >",
		viewMore: "查看更多",
		defaultAuthor: "先知命局",
	},
	podcast: {
		defaultAuthor: "命運解惑師",
	},
	views: {
		count: "{count} 次觀看",
		tenThousand: "{count} 萬次觀看",
		simple: "{count}次觀看",
	},
	load: {
		more: "加載更多",
		showMore: "點擊顯示更多",
		loading: "加載中...",
		done: "已全部加載完畢～",
	},
	empty: {
		text: "暫無任何記錄～",
	},
	pagination: {
		ariaLabel: "內容分頁",
		prev: "上一頁",
		next: "下一頁",
	},
	creatorApp: {
		title: "先知命局App",
		desc: "該功能需要在App上使用,請打開並登錄您的賬號使用",
		download: "下載App",
		open: "打開App",
		close: "關閉",
	},
	filter: {
		all: "全部",
	},
	contentType: {
		video: "視頻",
		article: "文章",
	},
	categories: {
		1: "情感婚姻",
		2: "事業財運",
		3: "生肖運勢",
		4: "星座塔羅",
		5: "家庭健康",
		6: "風水",
		7: "靈異",
		8: "開運晶典",
	},
	detail: {
		breadcrumb: "媒體廣場",
		pageTitle: "先知廣場詳情 - 先知命局",
		seo: {
			defaultTitle: "先知廣場",
			keywordsSuffix: "八字算命, 命理分析, 運勢預測",
			descriptionSuffix: "先知命局專業命理分析平台，提供精準的八字算命與運勢預測服務。",
			descriptionShort: "先知命局專業命理分析平台",
		},
		follow: "+ 追蹤",
		followed: "已追蹤",
		like: "點讚",
		share: "分享至",
		copyLink: "複製鏈接",
		copyLinkSuccess: "鏈接已複製",
		copyLinkFailed: "複製失敗，請重試",
		shareTo: "分享到{platform}",
		sharePlatform: "社交平台",
		comments: "評論",
		authorTag: "作者",
		commentPlaceholder: "說點什麼...",
		send: "發送",
		sending: "發送中...",
		replyPlaceholder: "回覆 {'@'}{nickname}",
		loading: "加載中...",
		collapseReplies: "收起回覆",
		viewReplies: "查看{count}條回覆",
		loadMoreReplies: "加載更多回覆",
		emptyComments: "暫無評論",
		emptyRecommend: "暫無相關播客~",
		loadMoreComments: "加載更多評論",
		commentSuccess: "評論成功",
		commentFailed: "評論失敗，請重試",
		replySuccess: "回覆成功",
		replyFailed: "回覆失敗，請重試",
		loginRequired: "請先登入",
		actionFailed: "操作失敗，請重試",
		shareTexts: ["看看這個有趣的內容！", "快來一起參與吧~", "這個分享太棒了，不容錯過！"],
		video: {
			playAria: "播放視頻：{title}",
			coverAlt: "{title}視頻封面",
			playButtonAlt: "播放按鈕",
			youtubePlayAria: "播放YouTube視頻：{title}",
			youtubeTitle: "YouTube視頻：{title}",
		},
		article: {
			coverAlt: "{title}封面",
		},
		articleSidebar: {
			hotTitle: "熱門內容",
			contactTeacher: "聯繫老師",
			yearsExperience: "從業年限",
			serviceCount: "服務人數",
			rating: "評分",
		},
		articleTeacher: {
			consultCount: "({count}人諮詢)",
		},
		shorts: {
			description: "說明",
			tabHot: "最熱門",
			tabNew: "最新",
			collapse: "收起",
		},
	},
};
